<template>
  <root-element
    :rootElement="documentElement"
    :entryItems="entryItems"
    v-if="documentElement"
    @updated="updated($event)"
  />
</template>

<script>
export default {
  name: "DocumentElement",
  props: ["documentElement", "entryItems"],
  methods: {
    updated(event) {
      this.$emit("updated", event);
      // console.log(event);
    }
  }
};
</script>

<style>
.templatesRowOdd {
  padding: 5px;
}

.templatesRowEven {
  padding: 5px;
  background: #eeeeee;
}

.templatesRowLeftSpacer {
  margin-left: 55px;
}

.templatesRowImage {
  float: left;
  border: 1px solid gray;
  width: 45px;
  height: 45px;
}

.templatesRowHidden {
  color: red;
}

.templatesRowVisible {
  color: green;
}

.templateRevision {
  padding: 10px;
  background: #dddddd;
  font-size: 8pt;
}

.templatePanel {
  border: 1px solid gray;
}

.templateHeading {
  font-size: 14pt;
  font-weight: bold;
}

.templateNavigator {
  padding: 5px;
  height: 600px;
  overflow: auto;
}

.templateBold {
  font-weight: bold;
}

.templateItalic {
  font-style: italic;
}

.templateUnderline {
  text-decoration: underline;
}

.templateOmit {
  border: 1px dotted gray;
}

.templateOmitToggle {
  font-size: 0.8em;
  color: gray;
  border-bottom: 1px dotted gray;
  margin-bottom: 5px;
}

.templateOmitSection {
  padding: 2px;
}

.templatePlaceholder {
  color: green;
}

.templatePlaceholderEntry {
  color: red;
}

.templateListSpace {
  margin-top: 0;
}

.templateListSpace li {
  margin-bottom: 1em;
}

.templateSpace {
  margin-bottom: 1em;
}

.templateIndent {
  margin-left: 10px;
}

.templateSelected {
  background: #ddddff;
}

.templateBorder {
  border: 1px solid gray;
}

.templatePad {
  padding: 3px;
}

.templateShade {
  background: #dddddd;
}

.templateCollapse {
  border-collapse: collapse;
}

.templateCentre {
  text-align: center;
}

.templateRight {
  text-align: right;
}

.templateMove {
  color: #dddddd;
  float: right;
  margin-left: 5px;
  float: right;
}

a.templateMove:link {
  text-decoration: none;
  color: blue;
}

a.templateMove:hover {
  text-decoration: underline;
  color: blue;
}

a.nostyle:link {
  text-decoration: inherit;
  color: inherit;
}

a.nostyle:visited {
  text-decoration: inherit;
  color: inherit;
}

.uploadItemArchived {
  text-decoration: line-through;
}

.documentItemArchived {
  text-decoration: line-through;
}

.virusCheck0 {
  color: orange;
}

.virusCheck1 {
  color: red;
}

.virusCheck2 {
  color: green;
}

.virusCheck3 {
  color: orange;
}

.document {
  padding: 15px;
  border: 5px solid gray;
}

.carats {
  color: red;
  font-weight: bold;
}

.scanTotal {
  color: gray;
}

.scanNav {
  margin-top: 15px;
  margin-bottom: 15px;
}

.scanNav td {
  width: 50%;
}

.scanForm {
  padding: 10px;
  border: 1px solid gray;
}

.scanImageSurround {
  background: #cccccc;
  padding: 5px;
}

.scanImage {
  border: 2px solid gray;
}

.templateHeaderBlock {
  float: left;
  padding: 5px;
  background: #dddddd;
  margin-right: 5px;
}

.revisionPublished {
  color: green;
}

.revisionEditable {
  color: red;
}

.documentTemplateCode {
  font-weight: bold;
}

.omitHidden {
  display: none;
}

.revisionCopyTemplate {
  background: green;
}

.padding {
  white-space: pre;
}
</style>
